// packages/shared-hooks/src/lead-activity/useCreateLeadFile.ts
//
// `POST /leads/:leadId/files` — bind a previously-uploaded object key
// (the caller has already PUT bytes through the presigned URL minted
// by `/files/upload-url` with `scope='lead-file'`). The metadata POST
// records the row + emits a `LEAD_FILE_UPLOADED` activity event in one
// transaction; invalidating the lead-activity capsule refreshes the
// list, the usage badge, and the feed (#1085).
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  LeadFileResponseSchema,
  type CreateLeadFileRequest,
  type LeadFileResponse,
} from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { leadActivityKeys } from './keys.js';

export function useCreateLeadFile(leadId: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<LeadFileResponse, unknown, CreateLeadFileRequest>({
    mutationFn: (input) =>
      client.post<LeadFileResponse>(`/leads/${leadId}/files`, input, {}, LeadFileResponseSchema),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: leadActivityKeys.forLead(leadId) });
    },
  });
}
